import { useProLaborLevelDesignations } from '@sbv-clients/data-access-api';

import { BaseSelectFilter } from '../shared/base-select-filter';

const options = [
  { id: '1', label: 'True', value: 1 },
  { id: '2', label: 'False', value: 2 },
];

export function HppdByPositionFilter({
  autoSelectIfEmpty,
  useContextFn,
  errorMessages = {},
}: {
  autoSelectIfEmpty?: boolean;
  useContextFn: () => {
    hppdByPosition: number;
    setHppdByPosition: (value: number) => void;
  };
  errorMessages?: Record<string, string>;
}) {
  const { hppdByPosition: value, setHppdByPosition: onChange } = useContextFn();
  const helperText = errorMessages['hppdByPosition'];
  const { PositionLaborLevel } = useProLaborLevelDesignations();

  return (
    <BaseSelectFilter
      autoSelectIfEmpty={autoSelectIfEmpty}
      label={`HPPD By ${PositionLaborLevel}`}
      options={options}
      value={value}
      onChange={onChange}
      error={!!helperText}
      helperText={helperText}
    />
  );
}
